import CopyButton from './copy-button.element.js';

export default CopyButton;

CopyButton.define('wje-copy-button', CopyButton);
